import { render, staticRenderFns } from "./ListaAgendamentos.vue?vue&type=template&id=48279b59&"
import script from "./ListaAgendamentos.vue?vue&type=script&lang=js&"
export * from "./ListaAgendamentos.vue?vue&type=script&lang=js&"
import style0 from "./ListaAgendamentos.vue?vue&type=style&index=0&id=48279b59&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports